import { message } from 'antd';
import { clearLogin, setLoginRedirect } from "../core/authUtil";
import { ACTION_TYPES } from '../actions';

const INIT_STATE = {
  message: '',
  type: '',
};

async function showErrorMessage(msg) {
  message.error(msg, 2);
}

function errors(state = INIT_STATE, action) {
  let result = state;
  const { type } = action;
  let { payload } = action;
  if (!payload) {
    payload = {};
  }
  const { message = '' } = payload;
  switch (type) {
    case ACTION_TYPES.ERROR_500:
      console.debug('ERROR_500', message);
      showErrorMessage('系统出现错误,请联系客服解决');
      result = {
        type,
        message,
      };
      break;
    case ACTION_TYPES.ERROR_401:
      console.debug('ERROR_401', message, document.cookie);
      showErrorMessage('登录信息已过期');
      clearLogin();
      setLoginRedirect(window.location.href);
      window.location.replace(`/login`);
      result = {
        type,
        message,
      };
      break;
    case ACTION_TYPES.ERROR_BIZ:
      console.debug('ERROR_BIZ', message);
      showErrorMessage(message);
      result = {
        type,
        message,
      };
      break;
    default:
      result = null;
  }
  return result;
}

export default errors;
